import React from "react";
import { AccountInfo } from "@azure/msal-browser";

export interface AdUser {
    user_principal_name: string;
    display_name: string;
    isAdmin: boolean;
    isPsh: boolean;
}

export interface AuthContextProps {
    account: AccountInfo;
    user: AdUser;
}

export const AuthContext = React.createContext<AuthContextProps>({
    account: {
        name: "",
        username: "",
        tenantId: "",
        environment: "",
        homeAccountId: "",
        idTokenClaims: {},
        localAccountId: "",
    },
    user: {
        user_principal_name: "",
        display_name: "",
        isAdmin: false,
        isPsh: false,
    },
});

export function useAdUser() {
    const { user } = React.useContext(AuthContext);
    return user;
}
